import localforage from "localforage";
import React, { useState } from "react";
import dataService from "../services/dataService";
import "./preferencetrackerstyles.css"

export default function CoinListItem({ name, symbol, id, upper, lower }) {
    const [upperLimit, setUpperLimit] = useState(upper)
    const [lowerLimit, setLowerLimit] = useState(lower)
    const [changed, setChanged] = useState(false)
    const [saveButtonMessage, setSaveButtonMessage] = useState("save")
    let saveButtonClass = changed ? "saveButton saveEnabled" : "saveButton saveDisabled"

    function handleUpperChange(e) {
        if (parseFloat(e.target.value) != NaN) {
            setChanged(true)
            setUpperLimit(e.target.value)
        }

    }

    function handleLowerChange(e) {
        if (parseFloat(e.target.value) != NaN) {
            setChanged(true)
            setLowerLimit(e.target.value)
        }

    }

    function saveLimits() {
        if (!changed) {
            return
        }
        localforage.getItem("preferences").then(localPreferences => {
            setSaveButtonMessage("saving...")
            let newPreferences = localPreferences.slice()
            console.log(newPreferences)
            for (var pref of newPreferences) {
                if (pref.coinId == id) {
                    pref.upper = upperLimit
                    pref.lower = lowerLimit
                    dataService.updateCoinDB(id, name, symbol, lowerLimit, upperLimit).then(res => {
                        console.log(res.message)
                        localforage.setItem("preferences", newPreferences)
                        setChanged(false)
                        setSaveButtonMessage("save")
                    })
                    break
                }
            }
        })
        // find this coin in localForage. If found, change it otherwise add to it
        // call save function to database
    }
    return (
        <div className="coinItem row">
            <div className="coin-title">{name} ({symbol})</div>
            <div className="input-wrapper">
                upper: <input className="pref-input" value={upperLimit} onChange={(event) => { handleUpperChange(event) }} placeholder={"upper limit"}>
                </input>
            </div>
            <div className="input-wrapper">
                lower: <input className="pref-input" value={lowerLimit} onChange={(event) => { handleLowerChange(event) }} placeholder={"lower limit"}>
                </input>
            </div>
            {/* Add Condition to render different button depending on if value has changed */}
            <button className={saveButtonClass} onClick={saveLimits}> {saveButtonMessage} </button>
        </div>
    )

}